import { useMutation } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { LeadQueryParams, LeadDataResponse } from '../types';
import { LEAD_LIST_KEY } from './constants';

const useGetLeadsList = () => {
    const req = useRequest();

    // [HWM-23014] `heroOrgIds` drives cross-provider search: an array reaches useRequest as
    // repeated ?hero_organization_id= keys instead of the single active org. Omit it for normal
    // browsing, which stays scoped to the active provider.
    const request = ({
        payload,
        heroOrgIds
    }: {
        payload: LeadQueryParams;
        heroOrgIds?: string[];
    }) => {
        return req<LeadDataResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/leads/`,
            method: 'POST',
            body: JSON.stringify(payload),
            ...(heroOrgIds?.length && { query: { hero_organization_id: heroOrgIds } })
        });
    };
    return useMutation({
        mutationFn: request,
        mutationKey: [LEAD_LIST_KEY]
    });
};

export default useGetLeadsList;
